export interface ProgressProps {
	value?: number;
	trackColor?: string;
	fillColor?: string;
	height?: number;
	className?: string;
	style?: React.CSSProperties;
}

export function Progress({
	value = 0,
	trackColor = "var(--color-dashboard-border)",
	fillColor = "var(--color-dashboard-accent)",
	height = 6,
	className,
	style,
}: ProgressProps) {
	return (
		<div
			className={className}
			style={{
				width: "100%",
				height,
				background: trackColor,
				borderRadius: height / 2,
				overflow: "hidden",
				...style,
			}}
		>
			<div
				style={{
					width: `${Math.min(100, Math.max(0, value))}%`,
					height: "100%",
					background: fillColor,
					borderRadius: height / 2,
					transition: "width 600ms cubic-bezier(0.22,1,0.36,1)",
				}}
			/>
		</div>
	);
}
